// Axios
import Axios from "./axios";

export const fetchWorkshopDetail = (id) => {
  return new Promise((resolve, reject) => {
    const data = Axios.get(`/academyworkshop/${id}`);
    resolve(data);
  });
};
